<script setup>
import { TabPanel } from "@headlessui/vue";

const props = defineProps({
  withoutBackground: {
    type: Boolean,
    required: false,
    default: false,
  },
  unmount: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>

<template>
  <TabPanel
    :class="{
      'relative z-10 rounded-t bg-white p-6 border border-gray-200':
        !withoutBackground,
    }"
    :unmount="props.unmount"
  >
    <slot />
  </TabPanel>
</template>
